const EditAgent = () => import(/* webpackChunkName: "agent" */ '@/components/agents/agent-edit');
const UploadAgentPdf = () =>
  import(/* webpackChunkName: "agent" */ '@/components/agents/agent-pdf-upload');

const AGENT_ROUTES = [
  {
    path: '/project/:projectCode/substation/:substationCode/agent/:agentCode/edit',
    name: 'editAgent',
    component: EditAgent,
    props: true
  },
  {
    path: '/project/:projectCode/substation/:substationCode/agents/:agentCode/:port/diagrams',
    name: 'uploadAgentPdf',
    component: UploadAgentPdf,
    props: true
  }
];

export default AGENT_ROUTES;
